// extracted by mini-css-extract-plugin
export default {"cardContainer":"styles_cardContainer__VyEs+","card":"styles_card__YC2fZ","remove":"styles_remove__06BWE","icon":"styles_icon__mNKkI"};